(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'true');

    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["side_cart"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", function () {
  new Swiper('.gift-thresholds', {
      slidesPerView: 1,
      initialSlide: 0,
      mousewheel: true,
      keyboard: true,
      navigation: {
        nextEl: ".gift-next",
        prevEl: ".gift-prev",
      }
  });
  getCurrentGiftSlide()

  new Swiper('.cart-upsell-products-swiper', {
      slidesPerView: 1.1,
      mousewheel: true,
      keyboard: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      }
    })

});

function getCurrentGiftSlide() {
  const threasholds = document.querySelectorAll('.gift-threshold')
  for (let i=0; i< threasholds.length;i++) {
    const threshold = threasholds[i]
    if (threshold.classList.contains('current-threshold')) {
      const swiper = document.querySelector('.gift-thresholds').swiper;
      swiper.slideTo(i)
    }

  }
}

function checkFreeGifts(cartTotal, line_items) {
  updateProgressBar(cartTotal)
}


const cartIcon = document.getElementById("cart-icon-bubble");
if(cartIcon) {
  cartIcon.addEventListener("click", function(e) {
    e.preventDefault()
    openSideCart()
  })
}

const addToCart = document.querySelectorAll('.wk-submit-button');
if (addToCart) {
  addToCart.forEach(function(elem) {
      elem.addEventListener("click", function(e) {
        setTimeout(async function(){
          loadCartAPI(true)
        },700) 
      })
  })
}

const closeCartBtn = document.getElementById("close_side_cart");
if(closeCartBtn) {
  closeCartBtn.addEventListener("click", function(e) {
    closeSideCart()
  })
}

const overlay = document.getElementById("side_cart_overlay");
if(overlay) {
  overlay.addEventListener("click", function(e){
      // prevent items behind from being clicked
      e.preventDefault()
      closeSideCart()
  })
}

function showCartNotification() {
  const cartNotification = document.querySelector('.cart-compact-notification');
  if (!cartNotification) return;

  // fade in the popup
  cartNotification.classList.remove('hidden');
  cartNotification.classList.add('active');

  // fade out the popup
  setTimeout(() => {
    cartNotification.classList.remove('active');
  }, 3500);
  // // hide popup from DOM
  setTimeout(() => {
    cartNotification.classList.add('hidden');
  }, 4000);
}

function openSideCart() {
  const sideCart = document.getElementById("side-cart")
  sideCart.style.display = 'block';

  
  const wiglotSelector = document.querySelectorAll('.weglot-container')[0]
  if (wiglotSelector) {
    wiglotSelector.style.display = 'none'
  } 

  const popout = document.querySelectorAll('.popout')[0]
  setTimeout(async function(){
    popout.classList.add("out")
  },10)
  document.body.classList.add('overflow-hidden')
}

function closeSideCart() {
  const sideCart = document.getElementById("side-cart")
  sideCart.style.display = 'none'
  const popout = document.querySelectorAll('.popout')[0]
  popout.classList.remove("out")
  document.body.classList.remove('overflow-hidden')

  const wiglotSelector = document.querySelectorAll('.weglot-container')[0]
  if (wiglotSelector) {
    wiglotSelector.style.display = 'inline-block'
  } 
}

function addItemButtonEvents() {

  const removeItem = document.querySelectorAll('.cart-product-remove')
  removeItem.forEach(function(elem) {
      elem.addEventListener("click", function(e) {
          const formData = {
            'id': e.target.parentElement.getAttribute('data-line-id'),
            'quantity': 0
          };
        callCartAPI(formData)
        elem.parentElement.parentElement.parentElement.remove()
        updateQuantity()

        const removeBtns = document.querySelectorAll('.cart-product-remove')
        removeBtns.forEach(function(elem) {
            elem.disabled = true
        })

      })
  })


  const minusItem = document.querySelectorAll('.cart-product-qty-minus')
  minusItem.forEach(function(elem) {
    elem.addEventListener("click", function(e) {
        const amountField = e.target.parentElement.querySelector('.cart-product-qty-amount')
        const qty = amountField.textContent
        const newQty = parseInt(qty) - 1
        amountField.textContent = newQty
        e.target.disabled = true

        const formData = {
            'id': e.target.getAttribute('data-line-id'),
            'quantity': newQty
          };
        callCartAPI(formData)
        updateQuantity()
      })
  })

  const plusItem = document.querySelectorAll('.cart-product-qty-plus')
  plusItem.forEach(function(elem) {
      elem.addEventListener("click", function(e) {
        const amountField = e.target.parentElement.querySelector('.cart-product-qty-amount')
        const qty = amountField.textContent
        const newQty = parseInt(qty) + 1
        amountField.textContent = newQty
        e.target.disabled = true
        
        const formData = {
            'id': e.target.getAttribute('data-line-id'),
            'quantity': newQty
          };
        callCartAPI(formData)
        updateQuantity()
      })
  })

  const sellingBtns = document.querySelectorAll('.cart-product-subscription-upgrade')
  for (const sellingBtn of sellingBtns) {
    sellingBtn.addEventListener("click",function(e) {
      e.target.parentElement.querySelector('.cart-select-subscription').style.display = 'block'
    })
  }

  const sellingSelects = document.querySelectorAll('.subcription-upgrade');

  for (const sellingSelect of sellingSelects) {
    sellingSelect.addEventListener("change", function(e) {
      const formData = {
        'id': e.target.dataset.key,
        'quantity': e.target.dataset.quantity,
        'selling_plan': e.target.value
      };
      callCartAPI(formData);
      sellingSelect.parentElement.style.display = 'none'
    })
  }
  

}
addItemButtonEvents()


function callCartAPI(formData) {
  fetch(window.Shopify.routes.root + 'cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    loadCartAPI()
    return response.json();
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}

let addingFreeGift = []
function callCartAPIAdd(formData) {
  // For free gifts, check and add atomically to prevent race conditions
  if (formData.items[0].properties && formData.items[0].properties['_gift-threshold']) {
    const itemId = formData.items[0].id;
    // If already adding this gift, return early
    if (addingFreeGift.includes(itemId)) {
      return;
    }
    // Add to array immediately to prevent duplicate calls
    addingFreeGift.push(itemId);
  }
  
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    loadCartAPI()
    return response.json();
  })
  .catch((error) => {
    console.error('Error:', error);
    // Remove from array if errored to allow retry
    if (formData.items[0].properties && formData.items[0].properties['_gift-threshold']) {
      const index = addingFreeGift.indexOf(formData.items[0].id);
      if (index > -1) {
        addingFreeGift.splice(index, 1);
      }
    }
  });
}

function shippingProtectionChecks(data) {
  const itemsProtectionSection = document.querySelectorAll('.product-shipping-protection-container')[0];
  if (itemsProtectionSection) {
    if(data.items.length <= 0) {
      itemsProtectionSection.style.display = 'none';
    } else {
      itemsProtectionSection.style.display = 'block';
    }

    let includeRemove = false;

    if(data.items.length == 1) {
      const item = data.items[0];
      if(item.title.includes('Protection')) {
        document.querySelector('.cart-product-remove img').click();
        document.querySelector('.shippingProtectionToggle').checked = false;
        includeRemove = true;

        const checkBox = document.getElementById("toggle");
        if (checkBox) {
          checkBox.checked = false
          addShippingProtection()
          sessionStorage.setItem('protectionAdded', false);
        }

        return;
      }
    }

    const includeShipping = data.items.some(item => item.title.includes('Protection'));
    let protectionAdded = sessionStorage.getItem('protectionAdded');

    if(!includeRemove && data.items.length > 0 && !includeShipping && !protectionAdded) {
        const checkBox = document.getElementById("toggle");
        if (checkBox) {
          checkBox.checked = true
          addShippingProtection()
          sessionStorage.setItem('protectionAdded', true);
        }
    }

  }

}

async function loadCartAPI(showCompactModal = false) {
  fetch(window.Shopify.routes.root + 'cart.js')
  .then(response => {
    return response.json();
  })
  .then(async (data) => {
    if (typeof syncTieredPromotionGifts === 'function') {
      const syncResult = await syncTieredPromotionGifts(data, { reload: false });
      if (syncResult && syncResult.mutated) {
        // Reuse the synced cart payload so threshold gift changes do not trigger a second full reload loop.
        data = syncResult.cartData;
      }
    }

    let showingBannerPopup = false;
    if (typeof updatePromotionalWidget === 'function') {
      showingBannerPopup = await updatePromotionalWidget(data);
    }
    updateQuantityDisplay(data.item_count)
    
    const currencySymbol = getCurrencySymbol()
    const removeImage = document.querySelectorAll('.cart-body')[0].getAttribute('data-remove-image')
    const itemsSection = document.querySelectorAll('.cart-products')[0]

    shippingProtectionChecks(data)

    let itemHtml = '';
    
    let compareAtPrice = 0
    let subtotalPrice = data.items_subtotal_price;
    for (const item of data.items) {
      itemHtml += await getProductLine(item, currencySymbol, removeImage)
      
      if (item.selling_plan_allocation && item.selling_plan_allocation.compare_at_price != item.selling_plan_allocation.price) {
          compareAtPrice += (item.selling_plan_allocation.compare_at_price * item.quantity)
      } else if (item.product_type == "Bundle") {
        compareAtPrice += (item.properties._compare_at_bundle * item.quantity)
      } else {
        compareAtPrice += (item.price * item.quantity)
      }
    }

    if(data.items.length == 0) {
      let emptCartSection = `<div class="cart-empty" `

      emptCartSection += `><span class="cart-empty-notice">Your cart is empty!</span>
            <a href="/" class="cart-empty-btn">Shop now</a>
          </div>` 
      itemsSection.innerHTML = emptCartSection;
    }else {
      itemsSection.innerHTML = ``;
    }
    
    itemsSection.innerHTML += itemHtml;

    const qualifyingTotal = getTieredPromotionQualifyingTotal(data) / 100;
    updateCartTotal(data.items_subtotal_price / 100, compareAtPrice / 100, qualifyingTotal)
    addItemButtonEvents()
    
    if (window.show_compact_notification) {

      // override ATC success popup if promo gift popup is being displayed
      if (showingBannerPopup) {
        showCompactModal = false;
      }
      if (showCompactModal) {
        showCartNotification()
      }
    } else {
      openSideCart()
    }
    
    if (data.items.length > 0) {
      document.querySelectorAll('.cart-body')[0].classList.add("with-footer")
      let recomend_id = data.items[0].product_id
      for (const itm of data.items) {
        if (itm.product_type != "Bundle") {
          recomend_id = itm.product_id
        }
      }
      loadRecomendations(recomend_id)
    } else {
      document.querySelectorAll('.cart-body')[0].classList.remove("with-footer")
    }
    
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}
window.loadCartAPI = loadCartAPI


async function getProductLine(item, currencySymbol, removeImage) {
  let selling_select = document.querySelector(`.cart-product-card[data-variant-id="${item.variant_id}"]`)?.querySelector('.cart-select-subscription')?.outerHTML
  if(!selling_select) {
    let plan_response = await fetch(`/products/${item.handle}?view=selling-plan`)
    if (plan_response.ok) {
      selling_select = await plan_response.text();
    }
  }

  if (selling_select) {
    // create div with html
    const div = document.createElement('div');
    div.innerHTML = selling_select;
    div.querySelector('.subcription-upgrade').setAttribute('data-key', item.key)
    div.querySelector('.subcription-upgrade').setAttribute('data-quantity', item.quantity)

    selling_select = div.innerHTML
  }
  

  // Cart API responses can return null properties, so normalize once before inspecting them.
  const itemProperties = item.properties || {};
  let lineItemHtml = `<div class="cart-product-card" data-variant-id="${item.variant_id}">
        <div class="cart-product-info">
          <div><img src="`+item.featured_image.url+`" alt="`+item.featured_image.alt+`" width="90" height="90" class="cart-product-image"></div>
            <div class="cart-product-details">
                <a class="cart-product-title" `+(item.final_price == 0 ? '' : 'href="'+item.url+'"')+`>`+item.product_title+`</a>
                <span class="cart-product-variant">` 
                if (item.product_has_only_default_variant == false || Object.keys(itemProperties).length > 0 || Object.hasOwn(item, 'selling_plan_allocation')) {
                  if (item.product_type != 'Bundle') {
                    lineItemHtml +=`<dl>`
                    if (item.product_has_only_default_variant == false) {
                      for (option of item.variant_options) {
                        if (!option.includes('ID')) {
                          lineItemHtml += `<div class="cart-product-option">`+option+`</div>`
                        }
                      }
                    }

                    for (const property in itemProperties) {
                      if (property.substring(0, 1) != '_') {
                          lineItemHtml += `<div class="cart-product-option">`+(property == 'Discount'?'Discount: ':'')+itemProperties[property]+`</div>`
                        }
                    }

                    lineItemHtml += `</dl>`
                  } else {
                    lineItemHtml += `<br>`
                  }
                  if (Object.hasOwn(item, 'selling_plan_allocation')) {
                    lineItemHtml += `<p class="cart-product-option">`+item.selling_plan_allocation.selling_plan.name+`</p>`
                  }
                }

                const is_tiered_promotion_gift = Object.hasOwn(itemProperties, '_gift-threshold');

                lineItemHtml += `
                </span>
                <div class="cart-product-numbers">
                    <div ${is_tiered_promotion_gift ? `style="display:none"` : ""} class="cart-product-qty">
                      <button type="button" class="cart-product-qty-button cart-product-qty-minus" data-line-id="`+item.key+`" `+(item.product_type == 'Bundle' ? 'style="display:none"':'')+`>-</button>`
                      if (item.product_type == 'Bundle') {
                        lineItemHtml +=`<span class="cart-product-qty-amount" style="width:100%" >`+item.quantity+`</span>`
                      } else {
                        lineItemHtml +=`<span class="cart-product-qty-amount" >`+item.quantity+`</span>`
                      }
                      lineItemHtml +=`<button type="button" class="cart-product-qty-button cart-product-qty-plus" data-line-id="`+item.key+`" `+(item.product_type == 'Bundle' ? 'style="display:none"':'')+`>+</button>
                    </div>`
                    if (is_tiered_promotion_gift) {
                      lineItemHtml +=`
                        <div class="cart-product-attributes">
                          <div class="cart-product-option cart-product-option--free-gift">
                            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#2D2D2DBF"><path d="M160-80v-440H80v-240h208q-5-9-6.5-19t-1.5-21q0-50 35-85t85-35q23 0 43 8.5t37 23.5q17-16 37-24t43-8q50 0 85 35t35 85q0 11-2 20.5t-6 19.5h208v240h-80v440H160Zm400-760q-17 0-28.5 11.5T520-800q0 17 11.5 28.5T560-760q17 0 28.5-11.5T600-800q0-17-11.5-28.5T560-840Zm-200 40q0 17 11.5 28.5T400-760q17 0 28.5-11.5T440-800q0-17-11.5-28.5T400-840q-17 0-28.5 11.5T360-800ZM160-680v80h280v-80H160Zm280 520v-360H240v360h200Zm80 0h200v-360H520v360Zm280-440v-80H520v80h280Z"/></svg>
                            Free Gift!
                          </div>
                        </div>`
                    }
                    lineItemHtml += `<div class="cart-product-prices">`
                      if (is_tiered_promotion_gift) {
                        lineItemHtml +=`<span class="cart-product-price is-free">FREE</span>`
                      } else if (item.selling_plan_allocation && item.selling_plan_allocation.compare_at_price != item.selling_plan_allocation.price) {
                        lineItemHtml +=`
                          <span class="cart-product-compare-at">`+currencySymbol+(item.selling_plan_allocation.compare_at_price/100).toFixed(2)+`</span>
                          <span class="cart-product-price has-compare">`+currencySymbol+(item.final_price/100).toFixed(2)+`</span>`
                      } else if (item.product_type == "Bundle") {
                        lineItemHtml +=`
                          <span class="cart-product-compare-at">`+currencySymbol+(item.properties._compare_at_bundle/100).toFixed(2)+`</span>
                          <span class="cart-product-price has-compare">`+currencySymbol+(item.final_price/100).toFixed(2)+`</span>`
                      } else if (item.final_price == 0) {
                        lineItemHtml +=`
                          <span class="cart-product-compare-at">`+currencySymbol+item.presentment_price.toFixed(2)+`</span>
                          <span class="cart-product-price has-compare">FREE</span>`
                      } else {
                        lineItemHtml +=`<span class="cart-product-price">`+currencySymbol+(item.final_price/100).toFixed(2)+`</span>`
                      }
                lineItemHtml +=`
                  </div>
                </div>`
                if (item.final_price != 0 && !is_tiered_promotion_gift) {
                  lineItemHtml +=`<button type="button" class="cart-product-remove" data-line-id="`+item.key+`" data-product-id="`+item.product_id+`">
                  <img width="15" height="20" src="`+removeImage+`" alt="remove">
                  </button>`
                }
                lineItemHtml +=`
            </div>
          </div>` +
            (!is_tiered_promotion_gift && (item.product_type != 'Bundle' && !Object.hasOwn(item, 'selling_plan_allocation')) ? `
            <button type="button" class="cart-product-subscription-upgrade">Upgrade to a subscription and save 10%</button>
            `:``)+( selling_select ? selling_select : '')+`
        </div>`

    return lineItemHtml;
}

function updateQuantity() {
  const amountFields = document.querySelectorAll('.cart-product-qty-amount')
  let newQty = 0
  amountFields.forEach(function(elem) {
    newQty += parseInt(elem.textContent)
  })

  updateQuantityDisplay(newQty)
}

function updateQuantityDisplay(newQty) {
  const cartTotalDisplays = document.querySelectorAll('.cart-item-count-number')
  cartTotalDisplays.forEach(function(elem) {
    elem.textContent = newQty
  })
  const headerCart = document.querySelectorAll('.cart-count-bubble')[0];
  headerCart.classList.remove('hidden', newQty !== 0);
  for (const dispNumber of headerCart.children) {
    dispNumber.textContent = newQty
  }
}

function updateCartTotal(newTotal, newCompare, qualifyingTotal = newTotal) {
  const cartFooter = document.querySelectorAll('.cart-static-footer')[0]
  
  const cartTotalDisplay = document.querySelectorAll('.cart-subtotal')[0]
  cartTotalDisplay.textContent = getCurrencySymbol() + newTotal.toFixed(2)

  const cartCompare = document.querySelectorAll('.cart-subtotal-compare-at')[0]
  if (newTotal != newCompare) {
    cartCompare.textContent = getCurrencySymbol() + newCompare.toFixed(2)
    cartTotalDisplay.classList.add('has-compare')
  } else {
    cartCompare.textContent = ''
    cartTotalDisplay.classList.remove('has-compare')
  }
  if (newTotal == 0) {
    cartFooter.style.display = 'none'
  } else {
    cartFooter.style.display = 'block'
  }

  updateProgressBar(qualifyingTotal)
}


function getCurrencySymbol() {
  if(document.querySelectorAll('.cart-upsell-products').length == 0) {
    return '$'
  }
  return document.querySelectorAll('.cart-upsell-products')[0].getAttribute("data-currency-symbol")
}

async function loadRecomendations(cartupsellid) {
  let existingCartItems = []
  for (const itm of document.querySelectorAll('.cart-product-remove')) {
    existingCartItems.push(itm.getAttribute("data-product-id"))
  }

  let upsellsSection = document.querySelectorAll('.cart-upsell-products')[0]

  if (!cartupsellid && upsellsSection) {
    cartupsellid = upsellsSection.getAttribute("data-recomend-id")
  }
  const currencySymbol = getCurrencySymbol()
  if (cartupsellid) {
    fetch(window.Shopify.routes.root + 'recommendations/products.json?limit=10&product_id='+cartupsellid)
    .then(response => {
      return response.json();
    })
    .then((data) => {
      let displayedCount = 0
      upsellsSection.innerHTML = '';
      for (const product of data.products) {
        if (product.type == "Bundle" || existingCartItems.includes(product.id) || product.tags.includes("pfs:hidden")) {
          continue
        }
        displayedCount++
        if (displayedCount > 4) {
          continue
        }
        let recomendationHtml = `<div class="cart-upsell-product swiper-slide">
            <div class="cart-upsell-row">
            <div><a href="`+product.url+`"><img src="`+product.featured_image+`" alt="" width="auto" height="75"></a></div>
            <div class="cart-upsell-text">
              <a href="`+product.url+`" class="cart-product-title">`+product.title+`</a>
              <span class="cart-upsell-price">`+currencySymbol+(product.price / 100)+`</span>
            </div>
            <div class="upsell-button-container">`
            if (product.variants.length == 1) {
              recomendationHtml += `<button type="button" data-variant-id="`+product.variants[0].id+`" class="cart-upsell-btn cart-upsell-add-btn">Add</button>`
            } else {
              recomendationHtml += `<button type="button" class="cart-upsell-btn cart-upsell-options-btn">Options</button>`
              
            }
            recomendationHtml += `</div></div>`
            if (product.variants.length != 1) {
              recomendationHtml += `<div class="cart-select"><select class="cart-upsell-variant ">`
              for (const variant of product.variants) {
                if (variant.available) {
                  recomendationHtml += `<option value="`+variant.id+`">`+variant.title+`</option>`
                }
              }
              recomendationHtml += `</select>
              <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"/>
              </svg></div>
              `
            }
            recomendationHtml += `</div>`
          upsellsSection.innerHTML += recomendationHtml
      }

      const swiper = document.querySelector('.cart-upsell-products-swiper').swiper;
      if (swiper) {
        swiper.destroy()
      }

      new Swiper('.cart-upsell-products-swiper', {
        slidesPerView: 1.1,
        mousewheel: true,
        keyboard: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      });

      const addButtons = document.querySelectorAll('.cart-upsell-add-btn')
      for (const addButton of addButtons) {
        addButton.addEventListener("click",function(e){

          const formData = {
            'items': [{
              'id': parseInt(e.target.getAttribute('data-variant-id')),
              'quantity': 1
              }]
            };

          callCartAPIAdd(formData)
          updateQuantity()
          e.target.parentElement.parentElement.parentElement.remove()
        })
      }
      
      const upsellButtons = document.querySelectorAll('.cart-upsell-options-btn')
      for (const upsellButton of upsellButtons) {
        upsellButton.addEventListener("click",function(e) {
          if (e.target.textContent == "Options") {
            e.target.parentElement.parentElement.parentElement.querySelector('.cart-select').style.display = 'block'
            e.target.textContent = 'Add'
          } else {
            const formData = {
            'items': [{
              'id': parseInt(e.target.parentElement.parentElement.parentElement.querySelector('.cart-upsell-variant').value),
              'quantity': 1
              }]
            };

            callCartAPIAdd(formData)
            updateQuantity()
            e.target.parentElement.parentElement.parentElement.remove()
          }
        })
      }
      
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }
}

loadRecomendations()

function updateProgressBar(cartTotal) {
  let giftPromotions = document.querySelector('.gift-thresholds .gift-threshold');
  if (!giftPromotions) {
    return;
  }
  const progressBarFills = document.querySelectorAll('.cart-progress-fill')
  for (progressFill of progressBarFills) {
    const fillStart = progressFill.getAttribute("data-start")
    const fillMax = progressFill.getAttribute("data-max") - fillStart
    

    let newPercent = ((cartTotal - fillStart) / fillMax) * 100
    if (newPercent < 0) {
      newPercent = 0
    }
    progressFill.style.width = newPercent+"%"
  }

  const progressMessages = document.querySelectorAll('.gift-threshold')

  let closest = null
  for (const message of progressMessages) {
     message.classList.remove('current-threshold')
     message.classList.remove('threshold-passed')
     message.classList.remove('all-met')
   }

  for (const message of progressMessages) {
    const threshold = message.getAttribute("data-threshold")
    if (threshold > cartTotal) {
      closest = message
      message.classList.add('threshold-passed')
      break
    }
  }
  if (closest === null) {
    closest = progressMessages[progressMessages.length-1]
    closest.classList.add('threshold-passed')
    closest.classList.add('all-met')
  }
  closest.classList.add('current-threshold')
  getCurrentGiftSlide()
    
}


  } catch(e) { console.error(e); }
})();
})();
